import { AppConstants } from '../app.constants';
import { Subscription } from 'rxjs/Rx';
import { Injectable, OnDestroy } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {LoginResponseModel} from '../model/LoginResponseModel';
import {IlanModel} from '../model/spring-model/Ilan.model';

@Injectable()
export class AuthenticationService implements OnDestroy {

    public adminTimer: Observable<void>;
    public adminTimerSubscription: Subscription;
    constructor(public http: HttpClient ) { }
    isSignedInAdmin(): boolean {
        return localStorage.getItem('currentUser') != null;
    }
    renewTokenAdminWithSubscription() {
        if (this.isSignedInAdmin()) {
            this.setAdminRenewalTimer();
        }
    }

    setAdminRenewalTimer() {
        // Renew the token every 1 hour
        // 3600000 ms = 1 hour 3600000
        this.adminTimer = Observable.interval(3600000)
            .map(
                () => {
                    this.renewTokenAdmin().subscribe( data => {
                      localStorage.setItem('currentUser', JSON.stringify({ name: data.body.userName , token: data.body.token , pass: data.body.pass , kullaniciPk: data.body.kullaniciPk }));
                    },
                      error => {
                      this.signoutAdmin();
                      });
                }
            );

        this.adminTimerSubscription = this.adminTimer.subscribe();
    }
    renewTokenAdmin():  Observable<HttpResponse<LoginResponseModel>> {
      const apiURL = AppConstants.API_ENDPOINT_SPRING + 'authenticate';
      return this.http.get<LoginResponseModel>(apiURL + '/renew-token/' + JSON.parse(localStorage.getItem('currentUser')).kullaniciPk + '/' + JSON.parse(localStorage.getItem('currentUser')).name + '/' + JSON.parse(localStorage.getItem('currentUser')).pass, { observe: 'response'});
    }
    signinAdmin(kullaniciAdi: string, password: string): Observable<HttpResponse<LoginResponseModel>> {
      const apiURL = AppConstants.API_ENDPOINT_SPRING + 'authenticate';
      return this.http.post<LoginResponseModel>(apiURL, { userName: kullaniciAdi , password: password}, { observe: 'response'});
    }
    unsubscriberAdminTimerSubscription() {
        if (this.adminTimerSubscription != null) {
            this.adminTimerSubscription.unsubscribe();
        }
    }
    signoutAdmin(): void {
        localStorage.removeItem('currentUser');
        this.unsubscriberAdminTimerSubscription();
    }
    ngOnDestroy() {
        this.unsubscriberAdminTimerSubscription();
    }
    getHeader(): HttpHeaders {
      if (new Date > JSON.parse(localStorage.getItem('currentUser')).tokenDate || JSON.parse(localStorage.getItem('currentUser')).tokenDate == null) {
        this.renewTokenAdmin().subscribe( data => {
          localStorage.setItem('currentUser', JSON.stringify({ name: data.body.userName , token: data.body.token , pass: data.body.pass , kullaniciPk: data.body.kullaniciPk , tokenDate: new Date().setTime(new Date().getTime() + (1000 * 60 * 60 * 10)) }));
        });
      }
      const headers = new HttpHeaders({
        Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('currentUser')).token
      });
      return headers;
    }
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/service/authentication.service.ts